import { render, staticRenderFns } from "./mocDetail.vue?vue&type=template&id=36aa3cd6"
import script from "./mocDetail.vue?vue&type=script&lang=js"
export * from "./mocDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36aa3cd6')) {
      api.createRecord('36aa3cd6', component.options)
    } else {
      api.reload('36aa3cd6', component.options)
    }
    module.hot.accept("./mocDetail.vue?vue&type=template&id=36aa3cd6", function () {
      api.rerender('36aa3cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/moc/mocDetail.vue"
export default component.exports